// Modules
import { useCallback, useEffect, useState } from "react";

// Types
import { Category } from "interfaces/searchPage/category";

// Redux
import { useAppSelector } from "redux/hooks";
import { categoriesSelector } from "redux/searchPage/categories/categoriesSlice";

// Utils
import { getNextUrl } from "utils/searchPage/queryString";

interface ValuesFilterAccordionContent {
	isActiveFilter: (categoryId: number) => boolean;
	nextUrl: string;
}

export const useFilterAccordionContent = (macroCategory: Category, selectedTags: Category[], currentTag: Category, urlPath: string): ValuesFilterAccordionContent => {
	const [nextUrl, setNextUrl] = useState("");
	const categories = useAppSelector(categoriesSelector);

	const buildHrefUrl = useCallback(
		(category: Category) => {
			if (selectedTags) {
				let updatedSelectedCategories: Category[] = [...selectedTags];
				if (selectedTags.find((selectedCategory) => selectedCategory.id === category.id)) {
					updatedSelectedCategories = selectedTags.filter((selectedCategory) => selectedCategory.id !== category.id);
				} else {
					updatedSelectedCategories.push(category);
				}

				const url = getNextUrl(macroCategory, updatedSelectedCategories, urlPath, categories);
				setNextUrl(url);
			}
		},
		[selectedTags, urlPath, categories, macroCategory, currentTag]
	);

	useEffect(() => {
		buildHrefUrl(currentTag);
	}, [selectedTags]);

	const isActiveFilter = (categoryId: number) => selectedTags.find((category) => category.id === categoryId) !== undefined;

	return { isActiveFilter, nextUrl };
};
